import type { EnvironmentId, ScopedThreadRef } from "@cmmd-forge/contracts";
import { create } from "zustand";

export interface ProjectContentSearchTarget {
  readonly cwd: string;
  readonly environmentId: EnvironmentId;
  readonly projectName: string;
  readonly threadRef: ScopedThreadRef;
}

interface ProjectContentSearchState {
  readonly target: ProjectContentSearchTarget | null;
  readonly close: () => void;
  readonly open: (target: ProjectContentSearchTarget) => void;
}

/**
 * Search is an app overlay, not a command-palette view. Keeping its target in
 * one small store lets the palette close before the overlay mounts, while the
 * result still retains the exact thread checkout it searched.
 */
export const useProjectContentSearchStore = create<ProjectContentSearchState>((set) => ({
  target: null,
  close: () => set({ target: null }),
  open: (target) => set({ target }),
}));
